<template>
  <div ref="resizableElement">
    <el-container>
      <!--   左边栏   -->
      <el-aside class="el-aside" width="250px" v-if="width >= 768" v-show="isFold" >
        <header class="logo-env">
          <div @click="clickSrc()">
            <img src="http://8.137.70.74:9010/i/2024/07/05/143125.png"  width="65%" alt="" />
          </div>
        </header>
        <div v-for="item in title" >
          <div class="jianju" v-if="item.children == null">
            <div class="gaoliang" @click="scrollToTarget(item.name)">
              <i class="el-icon-s-home"></i>
              <i class="nameJianju">{{item.name}}</i>
            </div>
          </div>

          <div class="jianju" v-else>
            <div @click="handleClick(item.id)">
              <el-row>
                <el-col :span="12">
                  <div class="gaoliang" >
                    <i class="el-icon-s-home"></i>
                    <i class="nameJianju">{{item.name}}</i>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="jianTou">
                    <i class="el-icon-arrow-right" style="font-size: 10px;" v-show="!currId || item.id !== currId"></i>
                    <i class="el-icon-arrow-down" style="font-size: 10px;" v-show="currId === item.id"></i>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-for="child in item.children">
              <div class="childrenJianju gaoliang" @click="scrollToTarget(child.name)" v-if="child.parentId == currId">
                <i>{{child.name}}</i>
              </div>
            </div>
          </div>

        </div>

<!--        <div class="jianju" id="no-select" v-if="loginShow">-->
<!--          <el-row>-->
<!--            <el-col :span="12">-->
<!--              <div class="gaoliang" @click="handleClick('palu')">-->
<!--                <i class="el-icon-s-home"></i>-->
<!--                <i class="nameJianju">幻兽帕鲁</i>-->
<!--              </div>-->
<!--            </el-col>-->
<!--            <el-col :span="12">-->
<!--              <div class="jianTou">-->
<!--                <i class="el-icon-arrow-right" style="font-size: 10px;" v-show="!currId || 'palu' !== currId"></i>-->
<!--                <i class="el-icon-arrow-down" style="font-size: 10px;" v-show="'palu' === currId"></i>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--          <div class="childrenJianju gaoliang" @click="startPalu()" v-if="'palu' === currId">-->
<!--            <i class="el-icon-video-play" size="mini" ></i>-->
<!--            <i class="nameJianju">启动</i>-->
<!--          </div>-->
<!--          <div class="childrenJianju gaoliang" @click="stopPalu()" v-if="'palu' === currId">-->
<!--            <i class="el-icon-video-pause" size="mini" ></i>-->
<!--            <i class="nameJianju">停止</i>-->
<!--          </div>-->
<!--          <div class="childrenJianju gaoliang" @click="restartPalu()" v-if="'palu' === currId">-->
<!--            <i class="el-icon-refresh" size="mini" ></i>-->
<!--            <i class="nameJianju">重启</i>-->
<!--          </div>-->
<!--        </div >-->
        <div class="jianju" id="no-select" v-if="loginShow">
          <el-row>
            <div @click="handleClick('admin')">
              <el-col :span="12">
                <div class="gaoliang">
                  <i class="el-icon-s-home"></i>
                  <i class="nameJianju">admin</i>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="jianTou">
                  <i class="el-icon-arrow-right" style="font-size: 10px;" v-show="!currId || 'admin' !== currId"></i>
                  <i class="el-icon-arrow-down" style="font-size: 10px;" v-show="'admin' === currId"></i>
                </div>
              </el-col>
            </div>
          </el-row>
          <div class="childrenJianju gaoliang" @click="goTo('classify')" v-if="'admin' === currId">
            <i>分类管理</i>
          </div>
          <div class="childrenJianju gaoliang" @click="goTo('website')" v-if="'admin' === currId">
            <i>网站管理</i>
          </div>
          <div class="childrenJianju gaoliang" @click="goTo('palu')" v-if="'admin' === currId">
            <i>幻兽帕鲁</i>
          </div>
        </div >
      </el-aside>
      <el-aside class="el-aside" width="80px" v-if="width >= 768" v-show="!isFold" >
        <div class="countup" id="no-select" >
          <i class="el-icon-data-line" size="mini" @click="cilLine()"></i>
        </div >
        <div class="countup" id="no-select" v-if="lineShow">
          <i class="el-icon-circle-plus-outline" size="mini" @click="cilLineK()"></i>
        </div >
      </el-aside>

      <el-container class="container">
        <!--   上边栏   -->
        <el-header class="el-header" v-if="width < 768" :height="(0.274*width).toString() + 'px'">
          <header :style="'line-height:' + (0.39*width).toString() + 'px' ">
            <a href="/public">
              <img src="http://8.137.70.74:9010/i/2024/07/05/143125.png" width="100%" alt="" />
            </a>
          </header>
        </el-header>

        <el-header class="el-header" v-if="width >= 768" height="75px">
          <i id="dingbu"></i>
          <el-row>
            <el-col :span="1" >
              <div class="fold">
                <i class="el-icon-s-fold" style="font-size: 20px;" @click="onfold" v-show="isFold"></i>
                <i class="el-icon-s-unfold" style="font-size: 20px;" @click="onfold" v-show="!isFold"></i>
              </div >
            </el-col>
            <el-col :span="1" >
              <div class="countup" id="no-select"  @dblclick="showPasswordInput">
                <ec-countup
                    :hidden="isShow"
                    :start="form.start"
                    :end="form.end"
                    :prefix="form.prefix"
                    :suffix="form.suffix"
                    :separator="form.separator"
                    :decimals="form.decimals"
                    :childEle="form.childEle"
                    :wrapEle="form.wrapEle"
                    :style="'color:' + coll"
                />
              </div >
            </el-col>
            <el-col :span="1" v-if="maxShow&&loginShow">
              <div class="countup" id="no-select" >
                <i class="el-icon-data-line" size="mini" @click="cilLine()"></i>
              </div >
            </el-col>

            <div class="form" v-if="maxShow&&!loginShow">
              <el-form inline class="inputStyle" >
                <el-form-item>
                  <el-input class="inputStyle" placeholder="请输入密码" size="mini" v-model="password" style="width: 150px;" show-password></el-input>
                </el-form-item>
                <el-form-item>
                  <div class="inputStyle">
                    <el-button type="primary" size="mini" @click="login()">登录</el-button>
                  </div>

                </el-form-item>
              </el-form>
            </div>
            <div class="form" v-if="maxShow&&loginShow">
              <el-form inline class="inputStyle">
                <el-form-item inline label="Min" v-if="loginRes === 'zc'">
                  <el-input class="inputStyle" size="mini" v-model="min" style="width: 70px;"></el-input>
                </el-form-item>
                <el-form-item inline label="Max" v-if="loginRes === 'zc'">
                  <el-input class="inputStyle" size="mini" v-model="max" style="width: 70px;"></el-input>
                </el-form-item>
                <el-form-item>
                  <div class="inputStyle">
                    <el-button type="primary" size="mini" v-if="loginRes === 'zc'" @click="submit(loginRes)">提交</el-button>
                    <el-button type="warning" size="mini" @click="pullTest()" :disabled="testLoading">test</el-button>
                    <el-button type="success" size="mini" @click="pullProd()">prod</el-button>
                    <el-button type="info" size="mini" @click="deployBackendAction()" :disabled="backendLoading">部署后端</el-button>
                    <el-button type="primary" size="mini" @click="deployFrontendAction()" :disabled="frontendLoading">部署前端</el-button>
                    <el-button type="primary" size="mini" @click="loginOut()" style="margin-top: -10px ">登出</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>

          </el-row>
        </el-header>

        <!--   主体   -->

        <!--        折线图-->
        <el-main class="el-main" v-if="mainType === 'line'">
          <el-form inline class="inputStyle" v-if="loginRes === 'zc' ? linesShow : loginRes">
            <el-form-item inline label="Min">
              <el-input class="inputStyle" size="mini" v-model="min" style="width: 70px;"></el-input>
            </el-form-item>
            <el-form-item inline label="Max">
              <el-input class="inputStyle" size="mini" v-model="max" style="width: 70px;"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="inputStyle">
                <el-button type="primary" size="mini" @click="submit(loginRes)">提交</el-button>
              </div>
            </el-form-item>
            <el-form-item inline label="代码">
              <el-input class="inputStyle" size="mini" v-model="code" style="width: 100px;"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="inputStyle">
                <el-button type="success" size="mini" @click="addCode()" :disabled="addShow">添加</el-button>
              </div>
            </el-form-item>
            <el-form-item inline label="代码">
              <el-select v-model="codeDel" filterable class="inputStyle" size="mini"  placeholder="请选择">
                <el-option :label="item.name" :value="item.code" v-for="item in codeAll" :key="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="inputStyle">
                <el-button type="danger" size="mini" @click="delCode()" :disabled="delShow">删除</el-button>
              </div>
            </el-form-item>
          </el-form>
          <el-row :gutter="32" v-if="!kShow">
            <el-col :span="12" >
              <line-chart></line-chart>
            </el-col>
<!--            动态折线图-->
            <div v-for="item in lineDate" v-if="loginRes === 'zc' ? linesShow : loginRes">
              <el-col :span="12" >
                <lines :lineDate.sync="item" :gp-code.sync="item[0].股票代码"></lines>
              </el-col>
            </div>
          </el-row>
          <el-row :gutter="32" v-if="kShow">
            <el-col :span="12" >
              <lineK></lineK>
            </el-col>
          </el-row>
        </el-main>
        <!--        分类管理-->
        <el-main class="el-main" v-else-if="mainType === 'classify'">
          <classify :getData="getData"></classify>
        </el-main>
        <!--        网站管理-->
        <el-main class="el-main" v-else-if="mainType === 'website'">
          <website :getData="getData"></website>
        </el-main>
        <!--        导航页图-->
        <el-main class="el-main" v-else>
          <div v-for="item in list">
            <i :id="item.title" class="el-icon-price-tag" style="font-size: 17px; font-weight: 250; line-height: 50px" v-show="item.sites != null">
              {{ item.title}}
            </i>
            <el-row :gutter="32">
              <el-col :span="span" v-for="sites in item.sites">
                <div class="xe-widget xe-conversations box2 label-info" @click="openInNewTab(sites.url)">
                  <div class="xe-comment-entry">
                    <el-container>
                      <div>
                        <el-avatar :src="sites.thumb || 'http://8.137.70.74:9010/i/2025/04/14/171534.ico'"> </el-avatar>
                      </div>
                      <div>
                        <span class="bold-text">{{sites.title}}</span><br>
                        <span class="gray-text">{{sites.description}}</span>
                      </div>
                    </el-container>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-main>

        <div style="text-align: center;line-height: 100px">备案号：
          <a href="http://beian.miit.gov.cn/" target="_blank" class="report-link" rel="noreferrer">
            <span class="report-link-text">渝ICP备2024046278号</span>
          </a>
        </div>

      </el-container>
    </el-container>
  </div>
</template>

<script>
import {
  ca,
  getLines,
  getMinMax,
  login,
  pullTest,
  strToSsh,
  delCode,
  addCode,
  restartPalu,
  getCategoryAuth,
  getTitleJson, getListJson,
  deployBackend,
  deployFrontend
} from "@/api/pyApi";
import {
  minMax
} from "@/api/javaApi";
import EcCountup from '@/components/EcCountup'
import lineChart from '@/components/Echarts/lineChart'
import lines from '@/components/Echarts/lines'
import lineK from '@/components/Echarts/lineK'
import classify from '@/views/admin/classify'
import website from '@/views/admin/website'
export default {
  components: {
    EcCountup,
    lineChart,
    lines,
    lineK,
    classify,
    website,
  },
  data() {







    return {
      list: [{"createTime":"2019-01-21 12:48:58","icon":"fa-star-o","id":1,"levels":1,"parentId":0,"sites":[{"categoryId":1,"categoryTitle":"me","createTime":"2024-02-23 15:42:43","description":"个人笔记本","id":303,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155759-0_4.png","title":"workspace","updateTime":"2024-02-23 15:47:05","url":"http://8.137.70.74:9000/"},{"categoryId":1,"categoryTitle":"me","createTime":"2024-03-01 09:09:07","description":"百度云","id":304,"thumb":"http://8.137.70.74:9010/i/2024/06/06/174931-0.png","title":"百度云","updateTime":"2024-06-06 17:49:32","url":"http://8.137.70.74:9001"},{"categoryId":1,"categoryTitle":"me","createTime":"2024-03-01 09:09:47","description":"qt","id":305,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/174856-0.png","title":"qt","updateTime":"2024-06-06 17:48:57","url":"http://8.137.70.74:9005"},{"categoryId":1,"categoryTitle":"me","createTime":"2024-03-04 16:55:00","description":"ql","id":307,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/174808-0.png","title":"ql","updateTime":"2024-06-06 17:48:09","url":"http://8.137.70.74:9002/"},{"categoryId":1,"categoryTitle":"me","createTime":"2024-03-06 15:09:29","description":"reader","id":309,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/174743-0.png","title":"reader","updateTime":"2024-06-06 17:47:45","url":"http://8.137.70.74:9007"},{"categoryId":1,"categoryTitle":"me","createTime":"2024-05-18 21:05:12","description":"床图","id":313,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/174830-0.png","title":"床图","updateTime":"2024-06-06 17:48:32","url":"http://8.137.70.74:9010"}],"sort":1,"title":"me"},{"createTime":"2019-01-21 13:53:10","icon":"fa-lightbulb-o","id":3,"levels":1,"parentId":0,"sort":2,"title":"教程"},{"createTime":"2019-01-21 12:50:17","icon":"fa-bullhorn","id":2,"levels":1,"parentId":0,"sites":[{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 15:58:34","description":"极简的IPv6地址查询工具，致力于普及 IPv6","id":1,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155753-0.png","title":"IP查询","updateTime":"2024-06-06 10:54:50","url":"https://ipw.cn/ipv6/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 06:27:26","description":"crontab执行时间计算","id":272,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155753-0_1.png","title":"  Cron表达式","updateTime":"2024-06-06 10:54:17","url":"https://tool.lu/crontab11"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 15:20:09","description":"文件格式转换1","id":273,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155753-0_2.png","title":"文件格式转换","updateTime":"2024-06-05 16:56:44","url":"https://convertio.co/zh/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 15:37:16","description":"在线 XML 格式化","id":274,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155754-0.png","title":"XML格式化","url":"https://c.runoob.com/front-end/710/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 15:48:06","description":"js在线运行工具","id":279,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155754-0_4.png","title":"js在线运行","url":"https://www.sojson.com/runjs.html"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-03-04 17:14:23","description":"json","id":410,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155754-0_4.png","title":"json","updateTime":"2024-06-06 17:50:31","url":"https://www.jyshare.com/front-end/53/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 15:49:07","description":"成语接龙查询","id":280,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155755-0.png","title":"成语接龙查询","url":"https://www.cyjl123.com/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 15:49:56","description":"Capslock+是一个加强 Capslock 键的功能，以提高效率的工具。","id":281,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155755-0_1.png","title":"Capslock+","url":"https://capslox.com/capslock-plus/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 15:50:49","description":"虚拟电话号码接收短信","id":282,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155755-0_2.png","title":"虚拟电话号码","url":"https://sms-activate.org/cn"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 15:55:50","description":"魔法工具","id":283,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155755-0_3.png","title":"xrelay","url":"https://xrelay.net/#/dashboard"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 16:03:03","description":"文档在线预览项目解决方案","id":285,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155756-0.png","title":"文档在线预览","url":"https://kkfileview.keking.cn/zh-cn/docs/home.html"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 16:06:07","description":"思维导图流程图","id":286,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155756-0_1.png","title":"ProcessOn","url":"https://www.processon.com/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 16:09:22","description":"其他格式的图标转为ICO图标","id":288,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155756-0_3.png","title":"ICO图标在线转换","url":"https://ico.nyaasu.top/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 16:11:45","description":"element官网","id":289,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155757-0.png","title":"element","updateTime":"2024-02-23 15:41:54","url":"https://element.eleme.cn/#/zh-CN/component/installation"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 16:12:24","description":"在线抠图工具","id":290,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155757-0_1.png","title":"在线抠图","url":"https://tool.lu/cutout/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 16:13:43","description":"前端菜鸟教程","id":291,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155757-0_2.png","title":" 菜鸟教程","updateTime":"2024-02-23 15:42:01","url":"https://www.runoob.com/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 16:15:07","description":"chatgpt","id":292,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155757-0_3.png","title":"chatgpt","updateTime":"2024-03-11 10:13:15","url":"https://chat.openai.com/chat"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-01-09 17:12:59","description":"AI 书 法 生 成 ● 在 线 书 法 字 典","id":293,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155757-0_4.png","title":"书 法 生 成","url":"http://www.shufaway.com/shufaway.php"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-03-01 15:01:35","description":"twsaver","id":306,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/175019-0.png","title":"twsaver","updateTime":"2024-06-06 17:50:20","url":"https://twsaver.com/zh/"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-03-04 17:14:23","description":"savetwitter","id":308,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/175031-0.png","title":"savetwitter","updateTime":"2024-06-06 17:50:31","url":"https://savetwitter.net/zh-cn"},{"categoryId":2,"categoryTitle":"工具箱","createTime":"2024-03-04 17:14:23","description":"3d模型","id":411,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155754-0_4.png","title":"3d模型","updateTime":"2024-06-06 17:50:31","url":"https://makerworld.com.cn/zh"}],"sort":3,"title":"工具箱"},{"createTime":"2019-01-21 13:53:31","icon":"fa-star-o","id":4,"levels":2,"parentId":3,"sites":[{"categoryId":4,"categoryTitle":"电脑","createTime":"2024-01-09 15:46:14","description":"U盘格式化教程","id":278,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155754-0_3.png","title":"U盘格式化","url":"https://zhuanlan.zhihu.com/p/97931380"},{"categoryId":4,"categoryTitle":"电脑","createTime":"2024-01-09 16:07:16","description":"win10顶级激活码大全分享","id":287,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155756-0_2.png","title":"win10顶级激活码","url":"http://www.xitong86.com/article/win10jc/5399.html"}],"sort":4,"title":"电脑"},{"createTime":"2019-01-21 13:53:49","icon":"fa-star-o","id":5,"levels":2,"parentId":3,"sites":[{"categoryId":5,"categoryTitle":"服务器","createTime":"2024-02-23 14:55:19","description":"Ubuntu虚拟内存的教程","id":302,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155759-0_2.png","title":"Ubuntu虚拟内存","url":"https://zhuanlan.zhihu.com/p/614905649"}],"sort":5,"title":"服务器"},{"createTime":"2019-01-21 13:54:00","icon":"fa-star-o","id":6,"levels":2,"parentId":3,"sort":6,"title":"网页灵感"},{"createTime":"2019-01-21 13:54:42","icon":"fa-thumbs-o-up","id":7,"levels":1,"parentId":0,"sort":7,"title":"素材资源"},{"createTime":"2019-01-21 13:54:59","icon":"fa-star-o","id":8,"levels":2,"parentId":7,"sites":[{"categoryId":8,"categoryTitle":"阿里云资源","createTime":"2024-01-12 16:06:02","description":"阿里云盘资源共享站","id":294,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155758-0.png","title":"我的小站","url":"https://pan666.net/"},{"categoryId":8,"categoryTitle":"阿里云资源","createTime":"2024-01-12 16:06:56","description":"我的小站防走丢","id":295,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155758-0_1.png","title":"我的小站防走丢","url":"https://pan666.cn/"},{"categoryId":8,"categoryTitle":"阿里云资源","createTime":"2024-01-12 16:08:08","description":"阿里云盘资源共享站","id":296,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155758-0_2.png","title":"狸猫盘搜","url":"https://www.alipansou.com/"},{"categoryId":8,"categoryTitle":"阿里云资源","createTime":"2024-01-12 16:09:34","description":"阿里云盘资源共享站\t","id":297,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155758-0_3.png","title":"小纸条","url":"https://ali.gitcafe.ink/"},{"categoryId":8,"categoryTitle":"阿里云资源","createTime":"2024-01-12 16:10:42","description":"阿里云盘资源共享站","id":298,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155758-0_4.png","title":"奈斯搜索","url":"https://www.niceso.net/"},{"categoryId":8,"categoryTitle":"阿里云资源","createTime":"2024-01-12 16:14:09","description":"阿里云盘资源共享站","id":299,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155759-0.png","title":"搜到你","url":"https://soudn.com/"},{"categoryId":8,"categoryTitle":"阿里云资源","createTime":"2024-01-09 15:45:22","description":"阿里云盘资源网站推荐","id":301,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155759-0_2.png","title":"阿里云盘资源","url":"https://zhuanlan.zhihu.com/p/661103574"}],"sort":8,"title":"阿里云资源"},{"createTime":"2019-01-21 13:55:11","icon":"fa-star-o","id":9,"levels":2,"parentId":7,"sites":[{"categoryId":9,"categoryTitle":"游戏资源","createTime":"2024-01-09 15:39:38","description":"吃鸡卡密","id":275,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155754-0_1.png","title":"卡密","url":"http://6699qk.xyz/"},{"categoryId":9,"categoryTitle":"游戏资源","createTime":"2024-01-09 15:41:29","description":"switch520永久防迷路","id":276,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155754-0_2.png","title":"永久防迷路","url":"https://sway.cloud.microsoft/1ESaLEE3x47BTgZC"},{"categoryId":9,"categoryTitle":"游戏资源","createTime":"2024-01-12 16:18:40","description":"switch游戏下载","id":300,"thumb":"http://8.137.70.74:9010/app/thumb.php?img=/i/2024/06/06/155759-0_1.png","title":"switch520","url":"https://www.gamer520.com/"}],"sort":9,"title":"游戏资源"},{"createTime":"2019-01-21 13:55:25","icon":"fa-star-o","id":10,"levels":2,"parentId":7,"sites":[{"categoryId":10,"categoryTitle":"其他资源","createTime":"2024-03-06 15:44:35","description":"阅读3.0","id":310,"title":"阅读3.0","updateTime":"2024-03-11 10:12:38","url":"https://gitee.com/ThomasYou/yd#https://gitee.com/ThomasYou/yd/raw/master/sy/3.0.json"},{"categoryId":10,"categoryTitle":"其他资源","createTime":"2024-03-06 17:28:56","description":"iptv","id":311,"title":"iptv","updateTime":"2024-03-11 10:12:30","url":"https://github.com/shidahuilang/shuyuan"}],"sort":10,"title":"其他资源"}],
      isFold: true,
      title: [{"icon":"fa-star-o","id":1,"ismenu":1,"levels":1,"name":"me","num":1,"parentId":0},{"children":[{"icon":"fa-star-o","id":4,"ismenu":1,"levels":2,"name":"电脑","num":4,"parentId":3},{"icon":"fa-star-o","id":5,"ismenu":1,"levels":2,"name":"服务器","num":5,"parentId":3},{"icon":"fa-star-o","id":6,"ismenu":1,"levels":2,"name":"网页灵感","num":6,"parentId":3}],"icon":"fa-lightbulb-o","id":3,"ismenu":1,"levels":1,"name":"教程","num":2,"parentId":0},{"icon":"fa-bullhorn","id":2,"ismenu":1,"levels":1,"name":"工具箱","num":3,"parentId":0},{"children":[{"icon":"fa-star-o","id":8,"ismenu":1,"levels":2,"name":"阿里云资源","num":8,"parentId":7},{"icon":"fa-star-o","id":9,"ismenu":1,"levels":2,"name":"游戏资源","num":9,"parentId":7},{"icon":"fa-star-o","id":10,"ismenu":1,"levels":2,"name":"其他资源","num":10,"parentId":7}],"icon":"fa-thumbs-o-up","id":7,"ismenu":1,"levels":1,"name":"素材资源","num":7,"parentId":0}],
      currId: '',






      form: {
        start: 16,
        end: 16,
        duration: 800,
        decimals: 2,
        separator: ',',
        prefix: '',
        suffix: '',
        wrapEle: 'span',
        childEle: 'em'
      },
      coll: '#0053ff',
      isShow: true,
      width: 0,
      span: 6,
      max: 0,
      min: 0,
      password: '',
      maxShow: false,
      loginShow: false,
      testLoading: false,
      backendLoading: false,
      frontendLoading: false,
      loginRes: '',
      lineShow: false,
      mainType: '',
      lineDate: [],
      code: '',
      codeDel: '',
      codeAll: [],
      addShow: false,
      delShow: false,
      kShow: false,
      linesShow: false
    }
  },
  mounted() {
    this.observeResize();
    this.dblclick();
    this.checkLogin();
    this.getData()
  },
  created() {
    const that = this
    if (that.isWorkTime('hou')) {
      ca().then(res => {
        that.form.start = res.data[1]
        that.form.end = res.data[0]
        if (res.data[0] > res.data[1]) {
          that.coll = '#ffc4f4'
        }else if (res.data[0] < res.data[1]){
          that.coll = '#81ffc5'
        }
        that.isShow = false
      })
    } else if (that.isWorkTime('qian')) {
      ca().then(res => {
        that.form.start = res.data[0]
        that.form.end = res.data[0]
        that.isShow = false
      })
    } else {
      ca().then(res => {
        that.form.start = res.data[0]
        that.form.end = res.data[0]
        if (res.data[0] > res.data[1]) {
          that.coll = '#ffc4f4'
        }else if (res.data[0] < res.data[1]){
          that.coll = '#81ffc5'
        }
        that.isShow = false
      })
    }
    this.getLines()
    setInterval(() => {
      if (that.isWorkTime()) {
          ca().then(res => {
            that.form.start = that.form.end
            that.form.end = res.data[0]
            if (res.data[0] > res.data[1]) {
              that.coll = '#ffc4f4'
            }else if (res.data[0] < res.data[1]){
              that.coll = '#81ffc5'
            }
            that.isShow = false
          })
        this.getLines()
      }
    }, 1000)

  },
  methods: {
    async getData(){
      try {
        const list = await getListJson()
        this.list = list.data
        const title = await getTitleJson()
        this.title = title.data
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    clickSrc(){
      const targetElement = document.getElementById("dingbu");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动
      }
    },
    addCode(){
      this.addShow = !this.addShow
      addCode({"gpCode": this.code}).then(res => {
        this.addShow = !this.addShow
        this.$message.success('添加成功!')
        location.reload();
      })
    },
    delCode(){
      this.delShow = !this.delShow
      delCode({"gpCode": this.codeDel}).then(res => {
        this.delShow = !this.delShow
        this.$message.success('删除成功!')
        location.reload();
      })
    },
    getLines(){
      getLines().then(res => {
        this.lineDate = []
        this.codeAll = []
        res.data.forEach(item => {
          const ite = JSON.parse(item)
          this.lineDate.push(JSON.parse(item))
          this.codeAll.push({
            "name": ite[0].股票名称,
            "code": ite[0].股票代码
          })
        })
      })
    },
    submit(type){
      minMax({min: this.min, max: this.max,type: type}).then(res => {
        if(res.data === "200") {
          this.$message.success('更新成功!')
        }
        this.maxShow = !this.maxShow
      })
    },
    login(){
      login({password: this.password}).then(res => {
        if (res.data !== 'error' && res.data) {
          this.loginShow = !this.loginShow
          this.loginRes = res.data
          //设置登录缓存
          this.setWithExpiry("userName",this.loginRes,3600000);
          this.dblclick()
          this.maxShow = !this.maxShow
          this.$message.success('登录成功!')
        }else {
          this.$message.error('登录失败!')
        }
      })
      // TODO 鉴权
      // getCategoryAuth({
      //   username: 'poke',
      //   password: 'zxc123'
      // }).then(res => {
      //   this.setWithExpiry("token",res.data.token,3600000);
      // }).catch(error => {
      //   console.error('Error:', error);
      // });

    },
   loginOut(){
       localStorage.removeItem("userName");
       //刷新页面
       location.reload();
   },
    cilLine(){
      this.lineShow = !this.lineShow
      // lineShow为true就展示折线图
      if(this.lineShow){
        this.mainType = 'line'
      }else {
        this.mainType = ''
      }
      this.linesShow = !this.linesShow
    },
    cilLineK(){
      this.kShow = !this.kShow
    },
    restartPalu(){
      restartPalu().then(res => {
        if("重启成功" === res.data){
          this.$message.success(res.data)
        }else {
          this.$message.error(res.data)
        }
      })
    },
    startPalu(){
      restartPalu().then(res => {
        if("重启成功" === res.data){
          this.$message.success("启动成功")
        }else {
          this.$message.error(res.data)
        }
      })
    },
    stopPalu(){
      var str = 'sh /home/poke/Steam/steamapps/common/PalServer/Pal/Saved/SaveGames/0/sh/paluStop.sh'
      strToSsh({string: str}).then(res => {
        //刷新页面
        this.$message.success('停止成功!')
      })
    },
    pullProd(){
      //正式环境更新
      var str = 'rm -rf /www/wwwroot/web/8989/static && rm -rf /www/wwwroot/web/8989/index.html && cp  /www/wwwroot/node/new-dh/dist/index.html  /www/wwwroot/web/8989 && cp -r /www/wwwroot/node/new-dh/dist/static  /www/wwwroot/web/8989'
      strToSsh({string: str}).then(res => {
        //刷新页面
        this.$message.success('正式环境更新成功!')
        location.reload();
        this.$message.success('正式环境更新成功!')
      })
    },
    deployBackendAction(){
      this.backendLoading = true
      deployBackend().then(res => {
        if(res.data && res.data.code === 200){
          this.$message.success(res.data.msg || '后端部署成功!')
        } else {
          this.$message.error(res.data.msg || '后端部署失败!')
        }
        this.backendLoading = false
      }).catch(() => {
        this.$message.error('后端部署请求失败!')
        this.backendLoading = false
      })
    },
    deployFrontendAction(){
      this.frontendLoading = true
      deployFrontend().then(res => {
        if(res.data && res.data.code === 200){
          this.$message.success(res.data.msg || '前端部署成功!')
        } else {
          this.$message.error(res.data.msg || '前端部署失败!')
        }
        this.frontendLoading = false
      }).catch(() => {
        this.$message.error('前端部署请求失败!')
        this.frontendLoading = false
      })
    },
    pullTest(){
      this.testLoading = true
      //测试环境更新
      pullTest().then(res => {
        //刷新页面
        // location.reload();
        this.$message.success('测试环境更新成功!')
        this.testLoading = false
      })
    },
    dblclick(){
      var data = this.getWithExpiry("userName");
      if(data !== null){
          this.loginRes = data
          getMinMax({type: data}).then(res => {
              this.min = res.data[0]
              this.max = res.data[1]
          })
      }
    },
      //展示密码输入框
    showPasswordInput(){
        this.maxShow = !this.maxShow
    },
    onfold(){
      this.isFold = !this.isFold;
    },
    // 定义打开新标签页的方法
    openInNewTab(url) {
      // 使用window.open打开新标签页
      window.open(url, '_blank');
    },
    handleClick(data) {
      if(this.currId == data){
        this.currId = '';
      }else{
        this.currId = data;
      }
    },
    scrollToTarget(id) {
      console.log(id)
      //展示导航页面
      this.mainType = ''
      const targetElement = document.getElementById(id);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动
      }
    },
    isWorkTime (type) {
      const now = new Date()
      const dayOfWeek = now.getDay() // 0 (周日) 到 6 (周六)
      const hours = now.getHours()
      const minutes = now.getMinutes()
      // 转换成今天的分钟数，从00:00开始算起
      const currentMinutes = hours * 60 + minutes
      // 周一到周五的9:30到11:30转换为分钟
      const startWorkMinutes = 9 * 60 + 30 // 周一到周五的9:30
      const endWorkMinutes = 11 * 60 + 30 // 周一到周五的11:30
      const startWorkMinutes1 = 13 * 60// 周一到周五的13:00
      const endWorkMinutes1 = 15 * 60 // 周一到周五的15:00
      // 判断是否在周一到周五
      const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5
      // 判断是否在9:30到11:30之间
      if (type === 'qian') {
        const isInWorkHours = currentMinutes <= startWorkMinutes
        // 综合判断
        return isWeekday && isInWorkHours
      } else if (type === 'hou') {
        const isInWorkHours = currentMinutes >= endWorkMinutes1
        // 综合判断
        return isWeekday && isInWorkHours
      } else {
        const isInWorkHours = currentMinutes >= startWorkMinutes && currentMinutes <= endWorkMinutes
        const isInWorkHours1 = currentMinutes >= startWorkMinutes1 && currentMinutes <= endWorkMinutes1
        // 综合判断
        return isWeekday && (isInWorkHours || isInWorkHours1)
      }
    },
    observeResize() {
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            this.width = window.innerWidth;
            if(this.width < 768){
              this.span = 24;
            }else {
              this.span = 6;
            }
          }
        });
        this.resizeObserver.observe(this.$refs.resizableElement);
      }
    },
      //设置过期时间的本地缓存
    setWithExpiry(key, value, ttl) {
        const now = new Date().getTime();
        // ttl in milliseconds (30 minutes * 60 seconds * 1000 ms)
        const expiry = now + ttl;
        localStorage.setItem(key, JSON.stringify({value, expiry}));
    },
      //获取本地缓存
    getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) return null; // 如果没有找到项目，则返回null
      const item = JSON.parse(itemStr);
      const now = new Date().getTime();
      // 检查是否已过期
      if (now > item.expiry) {
          // 如果已过期，删除该项目并返回null
          localStorage.removeItem(key);
          return null;
      }
      return item.value; // 如果未过期，返回项目值
    },
    //校验是否登录
    checkLogin() {
        var data = this.getWithExpiry("userName");
        if(data !== null){
            this.maxShow = false
            this.linesShow = !this.linesShow
            this.loginShow = !this.loginShow
        }
    },
  //  页面切换
    goTo(type) {
      this.mainType = type
    },
  }
}

</script>

<style>
/*小于768px*/
@media (max-width: 768px) {
  .el-header {
    background-color: #2e3031;
    color: #ffffff;
  }

  .el-main {
    background-color: #f9f9f9;
    color: #333;
    margin-left: 10px;
  }

}
/*大于等于768px*/
@media (min-width: 768px) {

  .el-header {
    background-color: #ffffff;
    color: #333;
  }

  .el-aside {
    background-color: #2e3031;
    color: #ffffff;
    line-height: 100vh;
    text-align: center;
    /* 如果需要侧边栏在页面滚动时固定位置，可以使用 position: sticky; */
    position: sticky;
    top: 0;
    height: 100vh;
    /* 或者使用 position: fixed; 使其脱离文档流，固定在视窗的某个位置 */
    /* position: fixed;
    top: 0;
    bottom: 0; */
  }

  .el-main {
    background-color: #f9f9f9;
    color: #333;
    margin-left: 10px;
  }
}

.container {
  background-color: #f9f9f9;
}

.logo-env{
  line-height: 90px;
}


.xe-widget.xe-conversations {
  position: relative;
  background: #fff;
  margin-bottom: 0px;
  padding: 15px;
}

.box2 {
  height: 86px;
  cursor: pointer;
  border-radius: 4px;
  padding: 0px 30px 0px 30px;
  background-color: #fff;
  overflow: hidden; /* 隐藏超出容器的部分 */
  border: 1px solid #e4ecf3;
  margin: 20px 0 0 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body {
  font-family: Arimo, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  color: #2c2e2f;
  background-color: #fff;
}

.el-icon-price-tag{
  display: flex;
  line-height: 50px;
}


.bold-text {
  font-weight: bold;
  text-align: left;
  position: relative; /* 或 absolute，根据你的需要 */
  left: 10px; /* 向右移动10px */
}

.gray-text {
  color: gray;
  text-align: left;
  font-size: 12px;
  position: relative; /* 或 absolute，根据你的需要 */
  left: 10px; /* 向右移动10px */
}

.el-icon-s-fold{
  color: gray;
  display: flex;
  line-height: 75px;
  margin-left: 20px;
}

.el-icon-s-unfold{
  color: gray;
  display: flex;
  line-height: 75px;
  margin-left: 20px;
}

.fold{
  cursor: pointer;
  margin-left: -20px;
  line-height: 80px;
}

.jianju {
  margin: 10px;
  margin-left: 50px;
  line-height: 35px;
  text-align: left;
  color: #989999;
  font-size: 13.5px;
  cursor: pointer;
}

.gaoliang:hover {
  /* 定义鼠标悬停时的样式 */
  /*background-color: yellow; !* 高亮背景色 *!*/
  color: #ffffff; /* 高亮文字颜色 */
}

.nameJianju {
  margin-left: 13.7px;
}

.childrenJianju {
  margin-left: 25px;
}

.jianTou {
  text-align: center;
  margin-left: 25px;
}

.countup {
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 700;
  color: #427af4;
  text-align: center;
  line-height: 75px;
}

/*不让文字复制*/
#no-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.inputStyle {

  line-height: 75px;
}

.form {
  /*margin-left: 25px;*/
  text-align: right;
}

.flex-container {
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: space-between; /* 左右两端对齐 */
}

.countup {
    margin-right: 8px; /* 可选：添加右边距，以增加图标和按钮之间的间距 */
}

.button-container {
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    /*background-color: #007bff; !* 蓝色背景 *!*/
    color: white; /* 白色文本颜色 */
    /*padding: 10px 20px; !* 内边距 *!*/
    border-radius: 5px; /* 圆角 */
}

</style>
